
import Typography from '@/ui-kit/components/typography';
import { TypographyType, TypographyProperty } from '@/ui-kit/components/typography/enums';
import Button from '@/ui-kit/components/button';
import {
  ButtonProperty,
  ButtonPropsEventType,
  ButtonFillType,
} from '@/ui-kit/components/button/enums';
import Icon from '@/ui-kit/components/icon';
import { IconProperty, IconType } from '@/ui-kit/components/icon/enums';
import Gutter from '@/ui-kit/components/gutter';
import { GutterProperty } from '@/ui-kit/components/gutter/enums';
import IconButton from '@/ui-kit/components/icon-button';
import { IconButtonProperty, IconButtonPropsEventType } from '@/ui-kit/components/icon-button/enums';
import ModalWindow from '@/ui-kit/components/modal/modal-window';
import { ModalSlotName, ModalViewType } from '@/ui-kit/components/modal/enums';
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import { ToastMessage } from '@/ui-kit/components/toast/enums';
import {
  StyleSizeType,
  StyleColorSchemeType,
  StyleFontWeightType,
  StylePositionType,
} from '@/ui-kit/styles/enums';
import MarketDataApiService from '@/services/api/market-data';
import NavigatorService from '@/services/Navigator';
import ToastService from '@/components/toast/toast-service';
import ExternalNavigationHelper from '@/utils/external-navigation';
import { track } from '@/utils/analytics';
import MarketDataShareModalForm from './form';
import { marketDataShareFormGroup } from './form/controls';
import { SOCIAL_BUTTONS_CONFIG, MODAL_COPY } from './constants';

export default {
  name: 'MarketDataShareModal',
  components: {
    Typography,
    MarketDataShareModalForm,
    ModalWindow,
    Button,
    IconButton,
    Icon,
    Gutter,
  },
  mixins: [ModalCommonProps],
  data() {
    return {
      TypographyType,
      ModalSlotName,
      ModalViewType,
      StyleSizeType,
      StyleColorSchemeType,
      StyleFontWeightType,
      StylePositionType,
      TypographyProperty,
      ButtonProperty,
      ButtonPropsEventType,
      SOCIAL_BUTTONS_CONFIG,
      IconProperty,
      IconType,
      GutterProperty,
      IconButtonProperty,
      IconButtonPropsEventType,
      ButtonFillType,
    };
  },
  computed: {
    isFormValid() {
      return marketDataShareFormGroup.isValid;
    },
    title() {
      return this.modalData?.title || MODAL_COPY.title;
    },
    socialShareCopy() {
      return this.modalData?.socialShareCopy || MODAL_COPY.socialShare;
    },
    shareSearchUrl() {
      return window.location.href;
    },
  },
  methods: {
    validateForm() {
      marketDataShareFormGroup.validate();
    },
    async handleSubmit() {
      const recipient = marketDataShareFormGroup.value;

      this.validateForm();

      if (!this.isFormValid) {
        return;
      }

      await MarketDataApiService.shareSearchByEmail({
        ...recipient,
        url: this.shareSearchUrl,
      });

      this.closeHandler(recipient);
      marketDataShareFormGroup.reset();
    },
    async handleShareLinkClick() {
      await NavigatorService.copyToClipboard(this.shareSearchUrl);

      ToastService.openPositive(ToastMessage.LinkCopied);
    },
    handleSocialShareClick({ shareBaseUrl, name }) {
      ExternalNavigationHelper.openInNewWindow(`${shareBaseUrl}${this.shareSearchUrl}`);
      track(`Market Data_Share chart by ${name} button click`);
      this.closeHandler(true);
    },
  },
};
